import { render, staticRenderFns } from "./IconPaperClipSolid.vue?vue&type=template&id=57b49c19"
import script from "./IconPaperClipSolid.vue?vue&type=script&lang=js"
export * from "./IconPaperClipSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports